<div class="add-history-void-detail-mode">
  <payline-detail-editor
    [args]="args"
    [payroll]="payroll"
    [startData]="startData"
    [earningConfigs]="earningConfigs"
    [deductionConfigs]="deductionConfigs"
    [taxConfigs]="taxConfigs"
    [employeePay]="employeePay">
  </payline-detail-editor>
  <div class="d-flex mt-2 justify-content-end">
    <button class="btn btn-secondary" (click)="onBack()">Back</button>
    <button class="btn btn-primary ms-3" (click)="onContinue()">Confirm & Continue</button>
  </div>
</div>
